import React from "react";

export type TbPlaceholderVariant = "phone" | "devices" | "screen" | "wide";

interface TbImagePlaceholderProps {
  label: string;
  hint?: string;
  variant?: TbPlaceholderVariant;
  className?: string;
}

const PlaceholderIcon: React.FC<{ variant: TbPlaceholderVariant }> = ({ variant }) => {
  if (variant === "devices") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="4" y="12" width="28" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="28" y="8" width="12" height="24" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="34" y="10" width="12" height="24" rx="2" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      </svg>
    );
  }

  if (variant === "phone") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="14" y="4" width="20" height="40" rx="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M20 38h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 18h40" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="14" r="2" fill="currentColor" />
    </svg>
  );
};

const TbImagePlaceholder: React.FC<TbImagePlaceholderProps> = ({
  label,
  hint,
  variant = "screen",
  className = "",
}) => (
  <div
    className={`tb-placeholder tb-placeholder--${variant} ${className}`.trim()}
    role="img"
    aria-label={`${label}${hint ? ` — ${hint}` : ""}`}
  >
    <div className="tb-placeholder__frame">
      <span className="tb-placeholder__icon">
        <PlaceholderIcon variant={variant} />
      </span>
      <span className="tb-placeholder__label">{label}</span>
      {hint && <span className="tb-placeholder__hint">{hint}</span>}
    </div>
  </div>
);

export default TbImagePlaceholder;
